import(/* webpackMode: "eager" */ "/vercel/path0/src/app/start/page.tsx");
